import type { MDBSelectEvents, MDBInputMaskEvents } from "./components/types";

export function createSelectEventHandler(el: HTMLElement, event: keyof MDBSelectEvents, callback: (event: any) => void) {
    el.addEventListener(event, callback)
}

export function createEventHandler(el: HTMLElement, event: keyof MDBSelectEvents | MDBInputMaskEvents, callback: (event: any) => void) {
    el.addEventListener(event, callback)
}

export async function adjustNotchWidth(label_el: HTMLLabelElement, notch_element: HTMLDivElement) {
    // Check if label is visible (offestWidth will equal 0 if not); if not, wait a tad (visibility changes may be slow)
    if (!label_el.checkVisibility()) {
        await new Promise(resolve => setTimeout(resolve, 10));
        if (!label_el.checkVisibility()) {
            console.error(`adjustNotchWidth(): Label ${label_el.innerText} is not visible`);
            return;
        }
    }
    if (label_el.offsetWidth > 0) {
        const labelWidth = label_el.offsetWidth * 0.8 + 5;
        notch_element.style.width = `${labelWidth}px`;
    } else {
        notch_element.style.width = `0px`;
    }
}


export type States = 'nuetral' | 'valid' | 'invalid' | 'active';
export let stateColors = { nuetral: 'black', active: '#3b71ca', valid: 'green', invalid: 'red' };